import React, { PropsWithChildren, useEffect, useRef, useState } from 'react';
import styles from './target-modal.module.scss';
import { Button } from '../button';
import { CloseIcon } from '@/assets/icons';
import clsx from 'clsx';
import { Typography } from '../typography';
import { createPortal } from 'react-dom';

export interface Props {
    className?: string;
    isOpen?: boolean;
    onClose?: () => void;
    title?: string;
    isDeskorTop?: boolean;
    withCloseButton?: boolean;
}

const ANIMATION_DELAY = 350;

export const TargetModal: React.FC<PropsWithChildren<Props>> = ({
    isOpen,
    onClose,
    children,
    title,
    isDeskorTop = true,
    withCloseButton = true,
    className,
}) => {
    const [isClosing, setIsClosing] = useState(false);
    const [visible, setVisible] = useState(isOpen);
    const refIdClosing = useRef<any>(null);

    useEffect(() => {
        clearTimeout(refIdClosing.current);
        if (isOpen) {
            setVisible(true);
            document.documentElement.classList.add('with-modal');
        } else {
            setIsClosing(true);
            refIdClosing.current = setTimeout(() => {
                setIsClosing(false);
                setVisible(false);
                document.documentElement.classList.remove('with-modal');
            }, ANIMATION_DELAY);
        }
    }, [isOpen]);

    if (!visible) {
        return null;
    }

    const modal = (
        <div
            className={clsx(styles.overlay, isClosing && styles.closing)}
            onClick={onClose}
        >
            <div
                className={clsx(className, styles.modal, isClosing && styles.closing, isDeskorTop && styles.dekorTop)}
                onClick={(e) => e.stopPropagation()} // Останавливает закрытие модалки при клике внутри нее
            >
                {title && (
                    <Typography
                        variant="p"
                        fontWeight="bold"
                        className={styles.title}
                        center
                    >
                        {title}
                    </Typography>
                )}
                {withCloseButton && (
                    <Button
                        className={styles.closeButton}
                        onClick={onClose}
                    >
                        <CloseIcon />
                    </Button>
                )}
                <div className={styles.content}>{children}</div>
            </div>
        </div>
    );

    return createPortal(modal, document.body);
};
